import { createFileRoute } from '@tanstack/react-router';
import { TransferDetailsPage } from '@/features/transfers-list/transfer-details-page.js';

export const Route = createFileRoute('/_app/transfers/$id')({
  component: RouteComponent,
});

function RouteComponent(): React.JSX.Element {
  const { id } = Route.useParams();
  return <TransferDetailsPage id={id} />;
}
